import * as React from "react";
import Workflow from "../../presentations/Workflow";

const WorkflowContainer = (props: any) => {

  const {data} = props;

  return (
    <div>
      <Workflow data={data}></Workflow>
    </div>
  );
};

export default WorkflowContainer;
